define('bizzabo/views/TopPanelView',[
    'jquery',
    'backbone',
    'underscore',
    'Handlebars',
    'bizzabo/models/Global',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/config',
    'bizzabo/bzapi',
    'bizzabo/views/NotificationView',
    'bizzabo/views/popup/EditSpeakerView',
    'bizzabo/views/popup/ThankYouView',
    'hbars!bizzabo/templates/topPanel'
], function(
    $,
    Backbone,
    _,
    Handlebars,
    Global,
    UTILS,
    Consts,
    CONFIG,
    BZAPI,
    NotificationView,
    EditSpeakerView,
    ThankYouView,
    template
    ) {

    var TopPanelView = Backbone.View.extend({

        events : {
            "click a[name='prevDay']" : "formPrevDayClick",
            "click a[name='nextDay']" : "formNextDayClick",
            'click .saveButtonTop' : 'saveBtnTopClicked',
            'click .publishButtonTop' : 'publishBtnTopClicked',
            'click .mainPanelHider' : 'formMainPanelHiderClicked',
            'click .backButton' : 'backButtonClicked',
            'click .previewButtonTop' : 'previewButtonTopClick'
        },

        previewButtonTopClick: function () {
            var model = this.model;
            var eventId = model.get('id');
            var uniqueName = model.get('unique-name');
            var eventRootUrl = model.getInternalWebsiteBaseUrl({ noUniqueName: true });
            var eventWebsiteUrl = model.getInternalWebsiteBaseUrl();

            var win = window.open('about:blank', '_blank');
            if (!win) {
                throw new Error('Could not open a new window');
            }

            BZAPI
                .authenticateOnEventWebsite(uniqueName, eventId, eventRootUrl)
                .then(function () {
                    win.document.location.href = eventWebsiteUrl;
                });
        },

        initialize : function() {
            _.bindAll(this, 'publishAll', 'saveAll', 'saveEventInformation', 'showBackdrop', 'hideBackdrop');
            this.listenTo(Backbone, Consts.Notifications.activeEvent.SWITCHED, this.modelActiveEventSwitched);
            this.listenTo(Backbone, Consts.Notifications.multiAdmin.EDITOR_NAME_CHANGED, this.showActiveEventNotification);
            this.listenTo(Backbone, Consts.Notifications.mainPage.SAVE_ALL_REQUEST, this.saveAll);
            this.listenTo(Backbone, Consts.Notifications.mainPage.SAVE_ALL_REQUEST, this.saveRequest);
            this.listenTo(Backbone, Consts.Notifications.mainPage.SAVE_ALL_REQUEST_COMPLETED, this.saveRequestCompleted);
            this.listenTo(Backbone, Consts.Notifications.mainPage.PUBLISH_ALL_REQUEST, this.publishAll);
            this.listenTo(Backbone, Consts.Notifications.mainPage.PUBLISH_ALL_REQUEST, this.publishRequest);
            this.listenTo(Backbone, Consts.Notifications.mainPage.PUBLISH_ALL_REQUEST_COMPLETED, this.publishRequestCompleted);
            this.listenTo(Backbone, Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, this.createNotification);
            this.listenTo(Backbone, Consts.Notifications.activeEvent.EVENT_INFO_SAVED, this.renderButtons);
            this.listenTo(Backbone, Consts.Notifications.activeEvent.AGENDA_SAVED, this.renderButtons);
            this.listenTo(Backbone, Consts.Notifications.activeEvent.EVENT_PUBLISHED, this.renderButtons);
            this.listenTo(Backbone, Consts.Notifications.signin.SIGNED_OUT, this.renderButtons);
            this.listenTo(Backbone, Consts.Notifications.signin.SIGNED_IN, this.renderButtons);
            this.listenTo(Backbone, Consts.Notifications.signin.SIGNED_IN, this.listenToEvent);
            $(window).bind('beforeunload', function() {
                if (Global.modelPool.isActiveEventNotSaved()) {
                    Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                        category : 'Organizer Responses',
                        action : 'Unsaved data confirmation- Navigating away'
                    });
                    return 'You have unsaved data.';
                }
            });
        },

        remove : function() {
            $(window).unbind('beforeunload');
            this.stopListening();
            this.$el.remove();
            return this;
        },

        render : function() {
            var obj = (this.model ? this.model.toJSON() : {});
            var html = template(obj);
            this.$el.html(html);
            this.renderButtons();
            return this;
        },

        renderButtons : function() {
            var statusText = '';
            var lastSavedText = '';
            var isLive = this.model ? this.model.isLive() : false;
            var isPendingApproval = this.model ? this.model.isPendingApproval() : false;
            var isPublished = this.model ? this.model.isPublished() : false;
            if (isPendingApproval) {
                statusText = 'Waiting for approval';
            } else if (isLive) {
                statusText = 'Live!';
                this.$('.top-panel-event-website-link').html(CONFIG.EVENTS_URL +'/'+ this.model.get('unique-name'));
                this.$('.top-panel-event-website-link').attr("href",CONFIG.EVENTS_URL +'/'+ this.model.get('unique-name'));
            }
            if (this.model && this.model.has('last-saved')) {
                lastSavedText = 'Last saved at ' + Handlebars.helpers.timeFormatFrom24Hour(this.model.get('lastSaved'));
            }
            this.$(".publishButtonTop").toggleClass('hide', isPublished);
            this.$("span.statusBlock").toggleClass('hide', !isPublished);
            this.$("span.statusBlock").html(statusText);
            this.$("span.lastSaved").html(lastSavedText);

            this.disableViewIfNeed();
        },

        disableViewIfNeed : function() {
            var disabled = (Global.modelPool.getActiveEvent() && Global.modelPool.getActiveEvent().get('event-is-active')) ? true : false;
            this.$('.saveButtonTop').toggleClass('disabled', disabled);
        },

        setModel : function(model) {
            this.model && this.stopListening(this.model);
            if (model) {
                this.model = model;
                this.listenTo(this.model, 'change:name', this.modelNameChanged);
                this.listenTo(this.model, 'change:header-logo-url', this.modelLogoChanged);
                this.listenTo(this.model, 'change:event-is-active', this.showActiveEventNotification);
                this.listenTo(Backbone, Consts.Notifications.multiAdmin.TAKE_OVER, this.showActiveEventNotification);
                this.showActiveEventNotification();
            }
            this.refreshAll();
        },

        showActiveEventNotification : function() {
            var msg;
            var socketPayload = Global.multiAdmin.getSocketPayload();
            var personName = socketPayload && socketPayload.personName;
            if (Global.multiAdmin.editorName === personName) {
                msg = 'You are currently editing this page from a different browser. if you take over, the other browser will be blocked from continuing to edit and will lose any unsaved data.';
            }
            else{
                msg = "The event is currently being edited by " + _.escape(Global.multiAdmin.editorName) + ", if you take over, "+ _.escape(Global.multiAdmin.editorName) + " will be blocked from continuing to edit and will lose any unsaved data."
            }
            if (this.model.get('event-is-active')) {
                var messageOptions = {
                    msg : msg,
                    autoHide : false,
                    showOkBtn : true,
                    hideAfter : 11000,
                    okCallBack : function() {
                        Global.multiAdmin.takeOver();
                    },
                    okBtnText : "Take Over",
                    errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.TIP
                };

                if (Global.multiAdmin.get('sameUser')) {
                    messageOptions.msg = "Someone is currently editing this event using the same user account as you in a different browser or tab. Avoid losing data by asking your account owner to invite you as a co-organizer.";
                    messageOptions.okBtnText = "Show me how";
                    messageOptions.okCallBack = function() {
                        window.open('http://help.bizzabo.com/customer/portal/articles/1423205-what-are-the-bizzabo-user-roles-', '_blank');
                    };
                }
                Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, messageOptions);
            } else {
                this.notificationView && this.notificationView.close();
            }
        },

        modelActiveEventSwitched : function() {
            this.setModel(Global.modelPool.getActiveEvent());
            this.listenTo(this.model, 'change:event-is-active', this.disableViewIfNeed);
        },

        refreshAll : function() {
            this.modelNameChanged();
            this.modelLogoChanged();
            this.renderButtons();
        },

        modelNameChanged : function() {
            var name = (this.model && this.model.has('name')) ? this.model.get('name') : Consts.Strings.eventDraft.DEFAULT_DRAFT_NAME;
            this.$('h1').text(name);
        },

        modelLogoChanged : function() {
            var logoURL = 'images/editEvent/emptyEventLogo.png';
            var hasLogo = (this.model && this.model.has('header-logo-url'));
            if (hasLogo) {
                logoURL = this.model.get('header-logo-url');
            }

            var thisImage = this.$('.topPanelLogo img');
            thisImage.fadeOut('slow', function() {
                thisImage.attr("src", logoURL);
                thisImage.fadeIn('slow');
            });
        },

        formPrevDayClick : function() {
            Backbone.trigger(Consts.Notifications.agenda.SCROLL_TO_PREV_DAY);
        },

        formNextDayClick : function() {
            Backbone.trigger(Consts.Notifications.agenda.SCROLL_TO_NEXT_DAY);
        },

        backButtonClicked : function() {
            var accountId = this.model.get('account-id');
            var eventId = this.model.get('id');
            window.location = CONFIG.DASHBOARD_URL + '/' + accountId + '/events/' + eventId + '/apps/agenda/editor';
        },

        saveBtnTopClicked : function() {
            if (this.$('a.saveButtonTop').hasClass('disabled') || this.$('a.publishButtonTop').hasClass('disabled')) {
                return;
            }
            Backbone.trigger(Consts.Notifications.mainPage.SAVE_ALL_REQUEST);
        },

        publishBtnTopClicked : function() {
            if (this.$('a.publishButtonTop').hasClass('disabled') || this.$('a.saveButtonTop').hasClass('disabled')) {
                return;
            }
            Backbone.trigger(Consts.Notifications.mainPage.PUBLISH_ALL_REQUEST);
        },

        formMainPanelHiderClicked : function() {
            Backbone.trigger(Consts.Notifications.mainPage.HIDER_CLICKED);
        },

        // Requests

        saveRequest : function() {
            this.$('a.saveButtonTop').addClass('disabled').text('Saving...');

            var paramsObject = {
                category : 'Organizer Actions',
                action : 'Save clicked'
            };
            if (Global.modelPool.getActiveEvent().isNew()) {
                paramsObject.label = 'New Event';
            }

            var activeEvent = Global.modelPool.getActiveEvent();
            var activeAgenda = Global.modelPool.getAgenda(activeEvent.get("id"));
            if ((!activeAgenda.wereSessionsSaved) && activeAgenda.wasEdited) {
                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Actions',
                    action : 'Add agenda requested'
                });
            }

            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, paramsObject);
        },

        saveRequestCompleted : function() {
            this.$('a.saveButtonTop').removeClass('disabled').text('Save');
        },

        publishRequest : function() {
            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Actions',
                action : 'Make live clicked'
            });
            this.$('a.publishButtonTop').addClass('disabled').text('Working...');
        },

        publishRequestCompleted : function() {
            this.$('a.publishButtonTop').removeClass('disabled').text('Make Live');
        },

        // Error messages

        errorMessage : function(firstError, numberOfErrors, tabDisplayName) {
            var otherIssuesMessage = function(n) {
                if (n === 0) {
                    return '';
                } else if (n === 1) {
                    return ' and one other issue.';
                } else {
                    return ' and ' + n + ' other issues.';
                }
            };
            return [
                firstError,
                otherIssuesMessage(numberOfErrors - 1),
                '<br>',
                'Your changes are not saved. Please fix the errors in the',
                tabDisplayName,
                'tab and save again.'
            ].join(' ');
        },

        showErrorMessage : function(firstError, numberOfErrors, tabDisplayName, tabName, extraSuffix) {
            Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                msg : this.errorMessage(firstError, numberOfErrors, tabDisplayName),
                showOkBtn : true,
                okBtnText : 'Take me to the ' + tabDisplayName + ' tab',
                okCallBack : function() {
                    Backbone.trigger(Consts.Notifications.leftPanel.SWITCH_TAB_REQUEST, tabName, extraSuffix);
                }
            });
        },

        showErrorMessageForSpeaker : function(firstError, numberOfErrors, tabDisplayName, speaker) {
            Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                msg : this.errorMessage(firstError, numberOfErrors, tabDisplayName),
                showOkBtn : true,
                okBtnText : 'Edit Speaker',
                okCallBack : function() {
                    new EditSpeakerView({
                        model: speaker
                    }).show();
                }
            });
        },

        showBackdrop : function() {
            this.completeBackdrop = $('<div class="complete-backdrop" />').appendTo(document.body);
            var mainContent = $('.main-content');
            if (mainContent) {
                this.backdrop = $('<div class="save-backdrop" />').appendTo(mainContent);
            }
        },

        hideBackdrop : function() {
            this.completeBackdrop && this.completeBackdrop.remove();
            this.completeBackdrop = undefined;

            this.backdrop && this.backdrop.remove();
            this.backdrop = undefined;
        },

        // Saving + Publishing

        saveAll : function(successCb, failureCb) {
            var thisView = this;

            var socketPayload = Global.multiAdmin.getSocketPayload();
            var roomName = socketPayload && socketPayload.roomName;

            var activeEvent = Global.modelPool.getActiveEvent();
            var isNewEvent = activeEvent.isNew();
            var eventWasFetched = (!activeEvent.shouldFetch);
            var shouldSaveEvent = (isNewEvent || eventWasFetched);

            var activeAgenda = Global.modelPool.getAgenda(activeEvent.get("id"));
            var agendaWasFetched = (!activeAgenda.shouldFetch);
            var shouldSaveAgenda = (isNewEvent || (agendaWasFetched && roomName === 'agenda'));

            var activePartners = Global.modelPool.getPartners(activeEvent.get("id"));
            var partnersWereFetched = (!activePartners.shouldFetch);
            var shouldSavePartners = (isNewEvent || (partnersWereFetched && roomName === 'sponsors'));

            var activePolls= Global.modelPool.getPolls(activeEvent.get("id"));
            var pollsWereFetched = (!activePolls.shouldFetch);
            var shouldSavePolls = (isNewEvent || pollsWereFetched && roomName === 'polls');

            var wrappedFailureCb = function() {
                thisView.hideBackdrop();
                _.defer(function() {
                    Backbone.trigger(Consts.Notifications.mainPage.SAVE_ALL_REQUEST_COMPLETED, false);
                });

                failureCb && failureCb();
            };

            var wrappedSuccessCb = function() {
                thisView.hideBackdrop();
                Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                    msg : "Event saved successfully",
                    errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.SUCCESS,
                    autoHide : true
                });
                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Responses',
                    action : 'Saved',
                    label : isNewEvent ? "New Event" : undefined
                });
                window._hsq && window._hsq.push(["trackEvent", {
                    id: "000000129684",
                    value: null
                }]);
                _.defer(function() {
                    Backbone.trigger(Consts.Notifications.mainPage.SAVE_ALL_REQUEST_COMPLETED, true);
                });
                successCb && successCb();
            };

            var savePartnersStep = function() {
                if (shouldSavePartners) {
                    thisView.savePartners(wrappedSuccessCb, wrappedFailureCb);
                } else {
                    wrappedSuccessCb();
                }
            };

            var saveAgendaStep = function() {
                if (shouldSaveAgenda) {
                    thisView.saveAgenda(savePartnersStep, wrappedFailureCb);
                } else {
                    savePartnersStep();
                }
            };

            var savePollsStep = function() {
                if (shouldSavePolls) {
                    thisView.savePolls(saveAgendaStep, wrappedFailureCb);
                } else {
                    saveAgendaStep();
                }
            };

            var saveEventStep = function() {
                if (shouldSaveEvent) {
                    thisView.saveEventInformation(function() {
                        if (isNewEvent) {
                            var eventId = parseInt(activeEvent.get('id'), 10);
                            Global.modelPool.setIdForNewEvent(eventId);
                            var servicePlan = Global.modelPool.getServicePlan(eventId);
                            if (servicePlan.id) {
                                servicePlan.set('event-id', eventId);
                                servicePlan.save();
                            }
                            Backbone.trigger(Consts.Notifications.router.EVENT_ID_CHANGED, eventId);
                        }
                        savePollsStep();
                    }, wrappedFailureCb);
                } else {
                    savePollsStep();
                }
            };

            Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                msg : "Saving...",
                errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.LOADING,
                autoHide : false
            });
            this.showBackdrop();
            saveEventStep();
        },

        publishAll : function() {
            var thisView = this;
            var triggerPublishCompleted = function() {
                _.defer(function() {
                    Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                        category : 'Organizer Responses',
                        action : 'Event published'
                    });
                    window._hsq && window._hsq.push(["trackEvent", {
                        id: "000000129683",
                        value: null
                    }]);

                    Backbone.trigger(Consts.Notifications.mainPage.PUBLISH_ALL_REQUEST_COMPLETED);
                });
            };

            this.saveAll(function() {
                thisView.publishEventInformation(triggerPublishCompleted, triggerPublishCompleted);
            }, triggerPublishCompleted);
        },

        validateEventInformation : function(activeEvent) {
            var isValid = true;
            if (_.isFunction(activeEvent.isValid) && _.isFunction(activeEvent.validate)) {
                var invalidAttributes = activeEvent.validate(null, {
                    forceUpdate : false
                });

                if (invalidAttributes) {
                    isValid = false;
                    var numberOfErrors = _.size(invalidAttributes);
                    var firstErrorKey = _.keys(invalidAttributes)[0];
                    var firstError = 'Event ' + invalidAttributes[firstErrorKey].toLowerCase();
                    this.showErrorMessage(firstError, numberOfErrors, 'information', 'EventInfo', '/focus/' + firstErrorKey);
                    Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                        category : 'Organizer Responses',
                        action : 'Failed to save event details- invalid data'
                    });
                }
            }
            return isValid;
        },

        saveEventInformation : function(successCb, failureCb) {
            var thisView = this;
            var activeEvent = Global.modelPool.getActiveEvent();
            activeEvent.wasEdited = true;
            var isValid = this.validateEventInformation(activeEvent);
            if (!isValid) {
                _.isFunction(failureCb) && failureCb();
                return;
            }

            activeEvent.save({}, {
                success : function() {
                    Backbone.trigger(Consts.Notifications.activeEvent.EVENT_INFO_SAVED, activeEvent.get('id'));
                    activeEvent.fetch();
                    _.isFunction(successCb) && successCb();
                },
                error : function(model, errorCode) {
                    if (errorCode === BZAPI.errorCodes.InvalidTokens) {
                        Backbone.trigger('loginRequest');
                    } else if (errorCode === BZAPI.errorCodes.NotAuthorized) {
                        Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                            msg : "You are not authorized to preform this action",
                            showOkBtn : true,
                            okBtnText : "Contact us for help",
                            okCallBack : function() {
                                thisView.contactUs('information issue');
                            }
                        });
                        Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                            category : 'Organizer Responses',
                            action : 'Failed to save event details'
                        });
                    } else {
                        Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                            msg : "Saving event information was not possible. Please try again",
                            showOkBtn : true,
                            okBtnText : "Contact us for help",
                            okCallBack : function() {
                                thisView.contactUs('information issue');
                            }
                        });
                        Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                            category : 'Organizer Responses',
                            action : 'Failed to save event details'
                        });
                    }
                    _.isFunction(failureCb) && failureCb();
                }
            });
        },

        publishEventInformation : function(successCb, failureCb) {
            var activeEvent = Global.modelPool.getActiveEvent();
            if (activeEvent.isPublished()) {
                Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                    msg : "Looks like this event was already published",
                    errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.WARNING
                });
                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Responses',
                    action : 'Tried to publish an already published event'
                });
                _.isFunction(failureCb) && failureCb();
                return;
            }

            activeEvent.publish({
                success : function() {
                    activeEvent.fetch({
                        success : function() {
                            Backbone.trigger(Consts.Notifications.activeEvent.EVENT_PUBLISHED, activeEvent.get('id'));
                            if (activeEvent.isLive()) {
                                //require(['bizzabo/views/popup/ThankYouView'], function(ThankYouView) {
                                    new ThankYouView({
                                        model : activeEvent
                                    }).show();
                                //});
                            }
                        }
                    });
                    Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                        msg : "Event published successfully!",
                        errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.SUCCESS,
                        autoHide : true
                    });
                    _.isFunction(successCb) && successCb();
                },
                error : function(errorCode) {
                    Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                        msg : "Publishing was not possible, please try again"
                    });
                    Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                        category : 'Organizer Responses',
                        action : 'Failed to publish event'
                    });
                    _.isFunction(failureCb) && failureCb();
                }
            });
        },

        saveAgenda : function(successCb, failureCb) {
            var activeEvent = Global.modelPool.getActiveEvent();
            var activeAgenda = Global.modelPool.getAgenda(activeEvent.get("id"));
            activeAgenda.validateSessions();
            activeAgenda.validateSpeakers();
            var numberOfDayErrors = UTILS.leafCount(activeAgenda.dayErrors || {});
            var numberOfSpeakerErrors = UTILS.leafCount(activeAgenda.speakerErrors || {});
            var numberOfErrors = numberOfDayErrors + numberOfSpeakerErrors;
            var invalidAttributes, firstErrorKey, firstError;
            if (numberOfDayErrors > 0) {
                invalidAttributes = activeAgenda.dayErrors || {};
                var firstErrorDay = _.values(invalidAttributes)[0];
                var firstErrorSessionCid = _.keys(firstErrorDay)[0];
                var firstErrorSession = firstErrorDay[firstErrorSessionCid];
                firstErrorKey = _.keys(firstErrorSession)[0];
                firstError = 'Session ' + firstErrorSession[firstErrorKey].toLowerCase();
                this.showErrorMessage(firstError, numberOfErrors, 'agenda', 'Agenda', '/session/' + firstErrorSessionCid + '/' + firstErrorKey);

                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Responses',
                    action : 'Failed to save agenda- invalid session'
                });
                failureCb && failureCb();
                return;
            }
            if (numberOfSpeakerErrors) {
                invalidAttributes = activeAgenda.speakerErrors || {};
                var cid = _.keys(invalidAttributes)[0];
                var firstErrorSpeaker = _.values(invalidAttributes)[0];
                firstErrorKey = _.keys(firstErrorSpeaker)[0];
                firstError = 'Speaker ' + firstErrorSpeaker[firstErrorKey].toLowerCase();
                var speaker = activeAgenda.get('speaker').get(cid);
                this.showErrorMessageForSpeaker(firstError, numberOfErrors, 'agenda', speaker);

                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Responses',
                    action : 'Failed to save agenda- invalid speaker'
                });
                failureCb && failureCb();
                return;
            }

            var thisView = this;
            activeAgenda.save({}, {
                success : function() {
                    Backbone.trigger('totango:trackEvent', 'Save agenda', 'Engagement management');
                    Backbone.trigger('totango:trackEvent', 'Save agenda', 'Website');
                    successCb && successCb();
                },
                error : function(model, errorCode) {
                    Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                        msg : "The agenda could not be saved, please try again",
                        showOkBtn : true,
                        okBtnText : "Contact us for help",
                        okCallBack : function() {
                            thisView.contactUs('agenda issue');
                        }
                    });
                    Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                        category : 'Organizer Responses',
                        action : 'Failed to save agenda'
                    });
                    _.isFunction(failureCb) && failureCb();
                }
            });
        },

        savePartners : function(successCb, failureCb) {
            var thisView = this;
            var activeEvent = Global.modelPool.getActiveEvent();
            var activePartners = Global.modelPool.getPartners(activeEvent.get("id"));
            var invalidAttributes = activePartners.validate();
            if (invalidAttributes) {
                var numberOfErrors = UTILS.leafCount(invalidAttributes);
                var firstErrorCid = _.keys(invalidAttributes)[0];
                var firstErrorItem = invalidAttributes[firstErrorCid];
                var firstErrorPartner = activePartners.get(firstErrorCid);
                var firstIsSponsor = (firstErrorPartner.get('partner-type') === 'sponsor');
                var firstErrorKey = _.keys(firstErrorItem)[0];
                var firstError = (firstIsSponsor ? 'Sponsor' : 'Exhibitor') + ' ' + firstErrorItem[firstErrorKey].toLowerCase();
                this.showErrorMessage(firstError, numberOfErrors, 'sponsors', 'Sponsors', '/' + firstErrorPartner.get('partner-type') + 's/' + firstErrorCid + '/' + firstErrorKey);

                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Responses',
                    action : 'Failed to save sponsors- invalid data'
                });
                _.isFunction(failureCb) && failureCb();
                return;
            }

            activePartners.save({
                success : function() {
                    Backbone.trigger('totango:trackEvent', 'Save agenda', 'Engagement management');
                    Backbone.trigger('totango:trackEvent', 'Save agenda', 'Website');
                    _.isFunction(successCb) && successCb();
                },
                error : function(model, errorCode) {
                    Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                        msg : "The sponsors could not be saved, please try again",
                        showOkBtn : true,
                        okBtnText : "Contact us for help",
                        okCallBack : function() {
                            thisView.contactUs('sponsors issue');
                        }
                    });
                    Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                        category : 'Organizer Responses',
                        action : 'Failed to save sponsors'
                    });
                    _.isFunction(failureCb) && failureCb();
                }
            });
        },

        savePolls : function(successCb, failureCb) {
            var thisView = this;
            var activeEvent = Global.modelPool.getActiveEvent();
            var activePolls= Global.modelPool.getPolls(activeEvent.get("id"));
            var invalidAttributes = false; //activePolls.validate();
            if (!activePolls.validate()) {
                this.showErrorMessage('', 1, 'polls', 'Polls', '');

                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Responses',
                    action : 'Failed to save polls- invalid data'
                });
                _.isFunction(failureCb) && failureCb();
                return;
            }

            var successFunction = function() {
                _.isFunction(successCb) && successCb();
            };
           if (activePolls.length > 0) {
               var callSuccess = _.after(activePolls.length, successFunction);

               activePolls.each(function(poll) {
                   if (poll.hasUnsavedData()) {
                       poll.save(null, {
                           success : function() {
                               callSuccess();
                           },
                           error : function(model, errorCode) {
                               Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                                   msg : "The polls could not be saved, please try again",
                                   showOkBtn : true,
                                   okBtnText : "Contact us for help",
                                   okCallBack : function() {
                                       thisView.contactUs('sponsors issue');
                                   }
                               });
                               Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                                   category : 'Organizer Responses',
                                   action : 'Failed to save polls'
                               });
                               _.isFunction(failureCb) && failureCb();
                           }
                       });
                   } else {
                       callSuccess();
                   }
               });
           } else {
               successFunction();
           }

        },

        createNotification : function(obj) {
            this.notificationView && this.notificationView.close();
            this.notificationView = new NotificationView(obj);
            $("header.top").before(this.notificationView.render().$el);
            this.notificationView.show();
        },

        contactUs : function(problem) {
            var params = [];
            params.push('interaction[name]=' + encodeURIComponent(Global.modelPool.getMe().get('full-name')));
            params.push('interaction[email]=' + encodeURIComponent(Global.modelPool.getMe().get('primary-email')));
            params.push('customer[company]=' + encodeURIComponent(Global.modelPool.getMe().get('company')));
            params.push('customer[custom1]=' + encodeURIComponent(Global.modelPool.getMe().get('country')));
            params.push('email[subject]=Can\'t%20save%20my%20event%20(' + problem + ')');
            var queryParams = params.join('&');
            window.open('https://bizzabo.zendesk.com/hc/en-us?' + queryParams);
        }

    });

    return TopPanelView;

});

